import React from 'react';

import { Link } from 'src/components/Inputs';

const LegalChangelog = ({ id }) => {
  return (
    <>
      <h2 id={id}>Legal Changelog</h2>
      <h4 id='changes' data-magellan-target='changes'>
        Changes to our legal policies
      </h4>
      <p>
        Our mission at Plaid is to enable innovation in financial services. As a
        result, we’re constantly working to improve our existing services, and
        to develop new services that give developers the ability to create
        amazing products, and for end users to connect their financial data to
        their favorite apps.
      </p>
      <p>
        As we make changes to our services, we review and update our legal
        policies to reflect those changes. Additionally, we may periodically
        revise and reorganize the language in our policies to make them easier
        to follow and understand.
      </p>
      <p>
        Stay up to date by reviewing highlights from the most recent changes to
        our policies below. And if you have any questions about the changes,
        please reach out to us at{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>
        .
      </p>
      <p>
        <strong>2026-09-28</strong>
      </p>
      <p>
        We updated our Plaid Account Terms (effective September 28, 2026) to
        describe the consumer services available through your Plaid Account,
        including streamlined access and onboarding, bank account monitoring and
        alerts, and Plaid CRA consumer reporting services. We also updated the
        terms on how your Plaid Account works, account management, permitted
        use, SMS and email, and security.
      </p>
      <p>
        <strong>2026-04-19</strong>
      </p>
      <p>
        We updated our Developer Policy (effective April 19, 2026) to reflect
        how the policy is incorporated into your agreement with Plaid; cover
        APIs, SDKs, and Plaid Consumer Reporting Agency, Inc.; add requirements
        for Authorized Users and Plaid Dashboard access controls; expand export
        and sanctions-related certifications; describe session replay and
        activity monitoring on the Plaid Dashboard; and revise security, data
        use, account deactivation, and other terms. Updated translations are
        available in French, Spanish, and German. We removed the archived 2019
        Developer Policy from the website.
      </p>
      <p>
        <strong>2026-04-14</strong>
      </p>
      <p>
        We updated our Plaid Account Terms to describe the Plaid Web-App and
        related monitoring and alerts, clarify third-party application
        terminology and how we use Plaid Account data (including when providing
        products or services you request), add a cross-reference to the Consumer
        Services Agreement for users of Plaid CRA services, and update account
        management, permitted use, and SMS support terms.
      </p>
      <p>
        <strong>2026-02-20</strong>
      </p>
      <p>
        Added French, Spanish, Portuguese, and Japanese translations for IDV
        Privacy Statement. Added French and Spanish translations for Biometric
        Policy and Release.
      </p>
      <p>
        <strong>2025-06-10</strong>
      </p>
      <p>
        We updated our Modulr Terms and Conditions to include the latest
        safeguarding information for the UK and EU.
      </p>
      <p>
        <strong>2024-11-12</strong>
      </p>
      <p>
        We updated our IDV Privacy Statement and added Plaid’s Biometric Policy
        and Release to our website.
      </p>
      <p>
        <strong>2024-02-26</strong>
      </p>
      <p>
        We updated our End User Privacy Policy and All Audience Privacy
        Statement.
      </p>
      <p>
        <strong>2024-02-01</strong>
      </p>
      <p>We updated our Global Candidate Privacy Notice.</p>
      <p>
        <strong>2023-12-01</strong>
      </p>
      <p>We updated our IDV Remember Me Terms with our Plaid Account Terms.</p>
      <p>
        <strong>2023-12-01</strong>
      </p>
      <p>We updated our SMS Terms.</p>
      <p>
        <strong>2023-11-14</strong>
      </p>
      <p>
        The All Audience Privacy Statement and Cookie Policy were updated to add
        Plaid CRA Inc.
      </p>
      <p>
        <strong>2023-08-22</strong>
      </p>
      <p>We updated our Cookie Policy with new cookie categories.</p>
      <p>
        <strong>2023-06-06</strong>
      </p>
      <p>We added the Modulr Terms and Conditions on our website.</p>
      <p>
        <strong>2023-06-02</strong>
      </p>
      <p>We updated our IDV Remember Me Terms.</p>
      <p>
        <strong>2023-05-012</strong>
      </p>
      <p>We added our IDV Remember Me Terms.</p>
      <p>
        <strong>2023-02-28</strong>
      </p>
      <p>
        We updated the End User Privacy Policy to make it easier to read and to
        cover products introduced in the last year.
      </p>
      <p>
        <strong>2023-01-12</strong>
      </p>
      <p>
        We removed fino's Terms and Conditions and Privacy policy from our
        website.
      </p>
      <p>
        <strong>2022-12-21</strong>
      </p>
      <p>
        We updated the Candidate Notice and All Audience Privacy Statement to
        clarify our privacy policies in light of the California Privacy Rights
        Act.
      </p>
      <p>
        <strong>2022-11-18</strong>
      </p>
      <p>We updated our SMS Terms.</p>
      <p>
        <strong>2022-08-04</strong>
      </p>
      <p>
        We updated the End User Privacy Policy and Privacy Statement to
        incorporate the Plaid IDV and Monitor products and make non-substantive
        edits for clarity.
      </p>
      <p>
        <strong>2022-01-31</strong>
      </p>
      <p>We updated our Developer Policy.</p>
      <p>
        <strong>2021-09-02</strong>
      </p>
      <p>
        We added English version of our EEA specific End User Services
        Agreement; and added fino's Terms and Conditions and Privacy policy to
        our website.
      </p>
      <p>
        <strong>2021-05-25</strong>
      </p>
      <p>We updated our Modern Slavery Act Transparency Statement</p>
      <p>
        <strong>2021-04-23</strong>
      </p>
      <p>
        We updated our End User Services Agreement (UK) to include more
        information regarding our payment initiation services.
      </p>
      <p>
        <strong>2021-03-17</strong>
      </p>
      <p>
        We added our Modern Slavery Act Transparency Statement to our website.
      </p>
      <p>
        <strong>2021-02-22</strong>
      </p>
      <p>
        We updated our End User Privacy Policy and Privacy Statement; translated
        our End User Privacy Policy, Privacy Statement, and Cookie Policy into
        Dutch; and added our End User Services Agreement in Dutch to our
        website.
      </p>
      <p>
        <strong>2020-07-15</strong>
      </p>
      <p>
        We translated our Privacy Statement, Developer Policy, and Cookie Policy
        into Spanish and French.
      </p>
      <p>
        <strong>2019-12-30</strong>
      </p>
      <p>
        We updated our End User Privacy Policy, Privacy Statement, Developer
        Policy, and Cookie Policy.
      </p>
      <p>
        <strong>2019-12-12</strong>
      </p>
      <p>We added our Candidate Privacy Notice to our website.</p>
      <p>
        <strong>2019-12-05</strong>
      </p>
      <p>
        We added our End User Services Agreement (US) and the SMS Terms to our
        website.
      </p>
      <p>
        <strong>2019-08-27</strong>
      </p>
      <p>We added our End User Services Agreement (UK) to our website.</p>
      <p>
        <strong>2019-05-29</strong>
      </p>
      <p>
        We added information to our{' '}
        <Link href='#end-user-privacy-policy'>
          <a>End User Privacy Policy</a>
        </Link>
        and{' '}
        <Link href='#privacy-statement'>
          <a>Privacy Statement</a>
        </Link>
        to address requirements of the European Union’s General Data Protection
        Regulation. Additionally, we added more details about the information we
        collect from end users. Lastly, we translated our{' '}
        <Link href='#política-de-privacidad-aplicable-al-usuario-final'>
          <a>End User Privacy Policy into Spanish</a>
        </Link>
        .
      </p>
      <p>
        <strong>2019-05-06</strong>
      </p>
      <p>
        We added our{' '}
        <Link href='#cookie-policy'>
          <a>Cookie Policy</a>
        </Link>{' '}
        to the website.
      </p>
    </>
  );
};

export default LegalChangelog;
